

































































































































































































import Carrousel from '../../../core/components/Carrousel.vue';
import ImagesStrip from '../../../core/components/ImagesStrip.vue';
import PictureModal from '../../../core/components/PictureModal.vue';
import ModalCheckboxList from '../../../core/components/ModalCheckboxList.vue'
import SimpleMap from '../../../core/components/SimpleMap.vue'
import DeleteConfirmation from '../../../tracking/components/Geofences/DeleteConfirmation.vue'
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    downloadFile,
    forceDownload,
    getDateToCustomFormat,
    getDateFormattedAsMoment,
    ColorsList,
    getUniqueId,
    customImageForMarker,
} from '../../../core/utils';
import { Destroyed } from '../../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../../core/mixins';
import { InsuranceServices } from '../../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { dateTypes } from '../../../core/models';
import ListWithItems from '../../../core/components/ListWithItems.vue';
import { generateZipFile } from '../../../norms';
import { getParsedBounds } from '../../../../features/insurance/utils';
import { SmartPathGenerate } from '../../../../features/insurance/api/harvestModels';

@Component({
    components: {
        Loading,
        Button,
        Carrousel,
        ImagesStrip,
        PictureModal,
        Combobox,
        ModalCheckboxList,
        DeleteConfirmation,
        SimpleMap,
        ListWithItems
    }
})
export default class RanchSatelliteImages extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) isCarrier: boolean;
    @Prop() vehicleID: number;
    @Prop({
        default() {
            return [];
        }
    })
    satelliteImages: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    ignoredPeriodsList: Array<object>;
    allSatelliteImages: Array<object> = [];
    @Prop({ default: -1 }) ranchId: number;
    @Prop({ default: '' }) ranchName: string;
    @Prop({ default: '' }) bandSelected: string;
    @Prop({ default: null }) ranchBounds: object | null;
    @Prop({ default: null }) bajoRinde: any | null;
    @Prop({ default: 0 }) currentCarouselIndex: number;
    @Prop({ default: 0 }) polygonsChanged: number;
    @Prop({ default: null }) mostRepresentativeImage: null | object;


    @Prop({default(){return []}}) ranchPolygons: Array<object>;
    performanceSelected: any = null;
    performanceRV: boolean = false;
    visibleModalDownloadImages: boolean = false;
    gettingSmartPoints: boolean = false;
    savingSmartRoute: boolean = false;
    dataLoaded: boolean = false;
    formatOptions: object = {
        csv: {
            title: 'CSV',
            key: 'csv',
        },
        png: {
            title: 'PNG',
            key: 'png',
        },
        tiff: {
            title: 'TIFF',
            key: 'tiff',
        }
    };
    downloadingImages: boolean = false;
    bandTypes: Array<string> = [];
    loadingMap: boolean = true;
    itemsManualFactors: Array<object> = [];
    pictureModalImage: string = '';
    visibleModalPicture: boolean = false;
    previousImageSelected: string | null = null;
    colorSmartRoute: string = ColorsList.orange;
    smartRouteIcon: string = 'mdi-access-point';

    layersItems: object = {
        see_ranch: {
            title: 'Chacra',
            key: 'see_ranch',
            checked: false,
            disabled: false,
            disabledTooltip: "La chacra no tiene polígono",
            icon: 'mdi-square-outline'
        },
        satellite_image: {
            title: 'Imagen Satelital',
            key: 'satellite_image',
            checked: true,
            disabled: false,
            icon: 'mdi-satellite-variant'
        }
    }

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    recalculatingImages: boolean = false;
    activeSmartRoute: boolean = false;
    imageBounds: object | null = null;
    pointsToVisit: Array<{
        lat: number,
        lng: number,
        id: string
    }> = [];
    smartRouteStartPoint: {
        lat: number,
        lng: number,
        id: string
    } | null = null;

    onDraggedMarker(latLng, markerType, markerId){
        let newLat = latLng.lat;
        let newLng = latLng.lng;
        let updatedMarker = {
            lat: newLat,
            lng: newLng,
            id: markerId
        }
        if(markerType === 'smart_start_point'){
            this.smartRouteStartPoint = updatedMarker;
        }

        if(markerType === 'smart_point_to_visit'){
            let pointIndex = this.pointsToVisit.findIndex((point) => point.id === markerId);
            if(pointIndex !== -1){
                this.pointsToVisit[pointIndex] = updatedMarker
            }
        }
    }



    groundOverlayClicked(latLng){
        if(this.activeSmartRoute && this.smartRouteStartPoint == null){
            this.smartRouteStartPoint = latLng;
            let imgPath = require("@/assets/google-marker-blue-dot.png")
            let marker = new google.maps.marker.AdvancedMarkerElement({
                position: latLng,
                title: 'Punto de partida',
                gmpDraggable: true,
                content: customImageForMarker(imgPath)
            });
            marker['type'] = 'smart_start_point';
            marker['id'] = getUniqueId();
            this.mapSatImages.addMarkerToMap(marker);
        }
    }

    clickBtnSmartRoute(){
        if(this.pointsToVisit.length > 0){
            this.setPointsToVisitOnMap(this.pointsToVisit);
        }else{
            this.gettingSmartPoints = true;
            InsuranceServices.getRanchPointsToVisit(
                this.ranchId
            ).then((res) => {
                this.pointsToVisit = res['points_to_visit'].map((point) => {
                    return {
                        lat: point['lat'],
                        lng: point['lng'],
                        id: getUniqueId()
                    }
                });
                this.setPointsToVisitOnMap(this.pointsToVisit);
            }).catch((error) => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudieron obtener los puntos a visitar'
                });
                
            }).finally(() => {
                this.gettingSmartPoints = false;
            })
        }
    }

    cancelSmartRoute(){
        this.activeSmartRoute = false;
        this.pointsToVisit = [];
        this.smartRouteStartPoint = null;
        this.mapSatImages.removeMarkersFromMap();
    }

    saveSmartRoute(){
        let self = this;
        if(this.smartRouteStartPoint){
            this.savingSmartRoute = true;
            let config: SmartPathGenerate = {
                ranch_id: Number(this.ranchId),
                starting_point: {
                    lat: this.smartRouteStartPoint.lat,
                    lng: this.smartRouteStartPoint.lng,
                },
                points_to_visit: this.pointsToVisit.map((point) => {
                    return {
                        lat: point.lat,
                        lng: point.lng
                    }
                })
            }
            InsuranceServices.generateSmartPath(
                config
            ).then((res) => {
                self.$_successLoadingDialog({
                    response: res
                });
            }).catch((error) => {
                self.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo generar la ruta inteligente'
                });
            }).finally(() => {
                self.savingSmartRoute = false;
                self.cancelSmartRoute();
            })
        }
    }

 

    setPointsToVisitOnMap(points: Array<{lat: number, lng: number, id:string}>){

        if(this.activeSmartRoute){
            return
        }
        
        let pointsAsGoogleMarkers: google.maps.marker.AdvancedMarkerElement[] = points.map((point) => {

            let imgPath = require("@/assets/google-marker-red-dot.png")
            let marker: google.maps.marker.AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                position: {
                    lat: point.lat,
                    lng: point.lng
                },
                title: 'Punto a visitar',
                gmpDraggable: true,
                content: customImageForMarker(imgPath)
            })
            marker['id'] = point.id;
            marker['type'] = 'smart_point_to_visit';
            return marker;
        });

        if(this.mapSatImages){
            this.mapSatImages.setMarkersOnMap(pointsAsGoogleMarkers);
            this.mapSatImages.toggleModalSmartRoute(true);
        }
        this.activeSmartRoute = true;
    }

    itemChanged(item) {
        // see_ranch o satellite_image
        switch (item['key']) {
            case 'see_ranch':
                this.toggleRanch(item['checked']);
                break;
            case 'satellite_image':
                this.toggleSatelliteImage(item['checked']);
                break;
        }
    }

    toggleSatelliteImage(visible){
        //aca
        if(visible){
            this.showImageOnMap()
        }else{
            this.hideImageOnMap();
        }
    }

    @Watch('polygonsChanged', { immediate: true })
    onPolygonsChangedChange(){
        let self = this;
        if(this.dataLoaded && this.layersItems['see_ranch']['checked']){
            if(this.ranchPolygons.length > 0){
               this.toggleRanch(false)

               setTimeout(() => {
                    self.toggleRanch(true)
               }, 0);
            }
        }
    }

    @Watch('ranchPolygons', { immediate: true })
    onRanchPolygonsChange(newPolygons){
        if(this.dataLoaded){
            if(this.ranchPolygons.length > 0){
                this.updateGeojsonInMap(newPolygons)
            }
        }
    }

    toggleRanch(visible) {
        //Chacra
        if(visible){
            //toggle checked 
            this.layersItems['see_ranch']['checked'] = true;
            //add geojson
            this.updateGeojsonInMap(this.ranchPolygons);
        }else{
            this.layersItems['see_ranch']['checked'] = false;
            if(this.mapSatImages && typeof this.mapSatImages.removeGeoJsonFeatures === 'function'){
                this.mapSatImages.removeGeoJsonFeatures();
            }
        }
    }

    @Watch('currentCarouselIndex', { immediate: true, deep: true })
    onCurrentCarouselIndexChange(index) {
        if(this.dataLoaded){
            this.clickedSatelliteImage(index)
        }
    }

    getImageReferencePosition(currentCarouselIndex){
        let position = currentCarouselIndex + 1;
        return position + '/' + this.getSatelliteImages.length
    }

    clickBtnRecalculateImages(){
        this.showDeleteConfirmationDialog(
            'Recalcular imágenes satelitales',
            'Ésta acción <b>eliminará</b> las imágenes satelitales actuales y se volverán a generar desde cero<br> con la información actual de la Chacra. <b>¿Está seguro que desea continuar?</b>'
        );
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.recalculateSatelliteImages();
        } else {
            this.confirmationDelete = false;
        }
    }

    recalculateSatelliteImages(){
        this.recalculatingImages = true;
        InsuranceServices.recalculateSatelliteImages(
            this.ranchId
        ).then((res) => {
            this.recalculatingImages = false;
            this.$_successLoadingDialog({
                response: res
            });
            this.removeSatelliteImagesFromRanch();
        }).catch((error) => {
            this.recalculatingImages = false;
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudieron recalcular las imágenes satelitales'
            });
        })
    }

    @Watch('satelliteImages', { immediate: true, deep: true })
    observableSatelliteImages(value){
        if(this.dataLoaded){
            this.allSatelliteImages = this.satelliteImages;
        }
    }
    @Watch('bandSelected', { immediate: true, deep: true })
    onBandSelectedChange(){
        if(this.dataLoaded){
            this.updateIndexWhenBandChanges()
        }
    }

    visibilityModalDownloadImages(value){
        this.visibleModalDownloadImages = value;
    }

    @Emit()
    removeSatelliteImagesFromRanch(){}

    @Emit()
    modifyRanch(feature:google.maps.Data.Feature){}

    @Emit()
    updateMostRepresentativeImage(imageObject) {
        return imageObject;
    }

     async downloadImageFromUrl(url) {
        try {
            let base64 = await InsuranceServices.downloadImageFromUrl(url);
            return base64;
        } catch (error) {
            return null;
        }
    }


    async downloadImagesAction(fileName: string, selectedFormats: Array<string>) {
        let baseImageName = this.ranchName !== '' ? this.ranchName : this.ranchId;
        if(typeof baseImageName === 'string'){
            baseImageName = baseImageName.replace(/[^\w]+/g, '_').replace(/__+/g, '_');
        }
        let dataToExport: any = {};
        this.downloadingImages = true;
        for (let index = 0; index < selectedFormats.length; index++) {
            const currentFormat = selectedFormats[index];
            let imageTimestamp = this.getSatelliteImages[this.currentCarouselIndex]['date'];
            let imageBand = this.getSatelliteImages[this.currentCarouselIndex]['band']
            let imageUrl = this.getSatelliteImages[this.currentCarouselIndex]
            switch(currentFormat){
                case 'csv':
                    imageUrl = imageUrl['csv_url'] 
                    let fileNameCSV = imageBand + '_imagen_satelital_chacra_' + baseImageName + '_'+ imageTimestamp + '.' + currentFormat
                    let imgCSV = await this.downloadImageFromUrl(imageUrl);
                        if (imgCSV !== null) {
                            dataToExport[fileNameCSV] = new Blob([imgCSV], { type: 'image/csv' });
                        } else {
                            this.$_showHistoricalError('No se pudo obtener la imagen satelital PNG');
                        }
                   
                    break;
                case 'png':
                    imageUrl = imageUrl['png_url'] 
                    let fileNamePNG = imageBand + '_imagen_satelital_chacra_' + baseImageName + '_'+ imageTimestamp +'.' + currentFormat
                     let imgPNG = await this.downloadImageFromUrl(imageUrl);
                        // let fileNameHumCSV = 'imagen_satelital_chacra_' + imageName + '.png';
                        if (imgPNG !== null) {
                            dataToExport[fileNamePNG] = new Blob([imgPNG], { type: 'image/png' });
                        } else {
                            this.$_showHistoricalError('No se pudo obtener la imagen satelital PNG');
                        }
                     break;
                case 'tiff':
                    imageUrl = imageUrl['tif_url'] 
                    let fileNameTIFF =  imageBand + '_imagen_satelital_chacra_' + baseImageName + '_'+ imageTimestamp + '.' + currentFormat
                     let imgTiff = await this.downloadImageFromUrl(imageUrl);
                        // let fileNameHumCSV = 'imagen_satelital_chacra_' + imageName + '.tiff';
                        if (imgPNG !== null) {
                            dataToExport[fileNameTIFF] = new Blob([imgTiff], { type: 'image/tiff' });
                        } else {
                            this.$_showHistoricalError('No se pudo obtener la imagen satelital TIFF');
                        }
                    break;
            }
        }
        let folderName = 'imagenes_satelitales_chacra_' + baseImageName;
        if(this.bandSelected !== ''){
            folderName += '_banda_' + this.bandSelected
        }
        generateZipFile(folderName, dataToExport, false);
        this.downloadingImages = false;
    }

    visibilityModalPictureImage(value) {
        this.visibleModalPicture = value;
    }

    rightArrowClickCarrousel() {
        this.imagesStripElement.scrollToRight();
    }
    leftArrowClickCarrousel() {
        this.imagesStripElement.scrollToLeft();
    }

    mouseOverStripImage(stripImageHover) {
        // this.pictureModalImage = stripImageHover['png_url'];
        // this.visibilityModalPictureImage(true);
    }

    get getSatelliteImages(){
        let images = this.allSatelliteImages;
        if(this.bandSelected !== ''){
            let bandSelected = this.bandSelected;
            let filteredImagesBySelectedBand = this.allSatelliteImages.map(function(image){
                return image
            }).filter((v, i, current) => (
                v['band'] === bandSelected
            ));
            images = filteredImagesBySelectedBand
        }
        return images
    }

    updateIndexWhenBandChanges(){
        let previousDateSelected = this.previousImageSelected;
        let indexToSelect = 0;
        let dateExistInNewImagesList = this.getSatelliteImages.findIndex(it => it['date'] === previousDateSelected);
        if(dateExistInNewImagesList !== -1){
            indexToSelect = dateExistInNewImagesList;
        }
        this.changedCarrouselIndex(indexToSelect)
        this.clickedSatelliteImage(indexToSelect);
    }

    get satelliteCarrousel(): HTMLFormElement {
        return this.$refs.carrouselSatellite as HTMLFormElement;
    }

    get imagesStripElement(): HTMLFormElement {
        return this.$refs.imagesStrip as HTMLFormElement;
    }



    clickedSatelliteImage(imageIndex, currentElement?) {
        this.changeCarrouselItem(imageIndex);
        this.showImageOnMap();
    }

    get mapSatImages(): HTMLFormElement {
        return this.$refs.mapSatelliteImages as HTMLFormElement;
    }

    fitMapToRanchBounds(){
        let self = this;
        this.$nextTick(() => {
            if(self.ranchBounds !== null && self.mapSatImages){
                self.mapSatImages.fitBounds(getParsedBounds(self.ranchBounds));
            }
        });
    }

    hideImageOnMap(){
        if(this.mapSatImages){
            this.mapSatImages.hideGroundOverlaysFromMap();
        }
    }


    showImageOnMap(){
        //quito las imagenes anteriores
        this.hideImageOnMap();
        let self = this;
        //agrego la imagen actual
        setTimeout(() => {
            let currentImage = self.getSatelliteImages[self.currentCarouselIndex];
            let currentImageBounds = currentImage['bounds'];
            let imageBounds = getParsedBounds(currentImageBounds);
            this.imageBounds = imageBounds;
            if(!imageBounds){
                self.$_showHistoricalError('No hay límites de la chacra para cargar la imagen satelital')
            }else{
                let imageUrl = currentImage['png_url'];
                if(self.mapSatImages){
                    self.mapSatImages.setGroundOverlayInMap(imageUrl, imageBounds, true);
                    self.mapSatImages.fitBounds(imageBounds);
                }
            }
        }, 0);
    }

    markAsRepresentative() {
        let currentImageId = this.getSatelliteImages[this.currentCarouselIndex]['id'];
        InsuranceServices.selectSatelliteImageAsRepresentative(this.ranchId, {
            id: currentImageId
        })
        .then(res => {
            this.$_showAddPointOfInterest(res['data']['message']);
            this.updateMostRepresentativeImage(this.getSatelliteImages[this.currentCarouselIndex]);
        })
        .catch(error => {});
    }

    updatePerformanceSelected(value) {
        this.performanceSelected = value;
    }

    @Emit()
    updateBandSelected(value) {}

    updatePerformanceRV(value) {
        this.performanceRV = value;
    }
    previewSettings() {
        // console.log('previewSettings');
    }
    applySettings() {
        // console.log('apply settings');
    }
    changeCarrouselItem(carrouselIndex: number) {
        this.changedCarrouselIndex(carrouselIndex);
        this.previousImageSelected = this.getSatelliteImages[carrouselIndex]['date'];
    }
    getParsedDate() {
        return getDateFormattedAsMoment(this.getSatelliteImages[this.currentCarouselIndex]['date'], dateTypes.dateYearFormatBars, dateTypes.dateYearFormatReverse)
    }

    @Emit()
    changedCarrouselIndex(value) {
        return value;
    }

    @Emit()
    updateChartCurrentTimestamp(value){return value}

    updatePlotLinesWithCurrentImage() {}

    setBandTypes() {
        let bandTypes: Array<string> = [];
        let hasNdviBand = false;

        for (let index = 0; index < this.satelliteImages.length; index++) {
            let currentBand = this.satelliteImages[index]['band'];
            if (!bandTypes.includes(currentBand)) {
                bandTypes.push(currentBand);
                if (currentBand === 'NDVI') {
                    hasNdviBand = true;
                }
            }
        }

        this.bandTypes = bandTypes.sort((a, b) => a.localeCompare(b));

        let ndviBandIndex = 0;

        ndviBandIndex = this.bandTypes.findIndex(band => band === 'NDVI')

        if (ndviBandIndex === -1) {
            ndviBandIndex = this.bandTypes.findIndex(band => band.includes('NDVI'));
            
            if (ndviBandIndex === -1) {
                ndviBandIndex = 0;
            }
        }

        this.preselectNdviBand(ndviBandIndex);;
    }


    preselectNdviBand(ndviBandIndex: number){
        if(ndviBandIndex !== -1){
            this.updateBandSelected(this.bandTypes[ndviBandIndex]);
            if(this.mapSatImages){
                this.mapSatImages.toggleExpansionPanel();
                this.showImageOnMap();
            }
        }
    }

    checkIfExistRanchPolygon(){
        let self = this;
        if(this.ranchPolygons.length == 0){
            this.layersItems['see_ranch']['disabled'] = true;
            this.layersItems['see_ranch']['checked'] = false;
        }
    }

    updateGeojsonInMap(newPolygons){
        let self = this;
        this.$nextTick(() => {
            if(self.mapSatImages){
                self.mapSatImages.addGeoJson({
                    type: 'FeatureCollection',
                    features: newPolygons
                })
                if(self.imageBounds !== null){
                    self.mapSatImages.fitBounds(self.imageBounds);
                }else{
                    self.mapSatImages.fitBounds(getParsedBounds(self.ranchBounds));
                }
            }
        })
    }

   

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.allSatelliteImages = self.satelliteImages;
            self.setBandTypes();
            self.checkIfExistRanchPolygon();
            self.dataLoaded = true;
        });

        EventBus.$on(TypeEventBus.MODIFY_RANCH_IN_SATELLITAL, (feature) => {
            self.modifyPolygonInMap(feature);
        });
    }

    @Emit()
    modifyRanchPolygon(feature: google.maps.Data.Feature){}

    modifyPolygonInMap(feature: google.maps.Data.Feature){
        if(this.mapSatImages){
            this.mapSatImages.modifyPolygon(feature)
        }
    }
}
